import { create } from "zustand";
import { filterVisibleLiveTransactions } from "../utils/liveTransactionFilters";

interface TrackedTransaction {
  _id: string;
  status?: string;
  createdAt?: string | number | Date;
  transactionType?: string;
  cryptoAsset?: string;
  assetIcon?: string;
  chain?: string | { chain?: string };
  network?: string;
  chainName?: string;
  amount?: string | number;
  transactionHash?: string;
  explorerUrl?: string;
  explorerTxPath?: string;
  statusUnavailable?: boolean;
  failureReason?: string;
  [key: string]: unknown;
}

interface TransactionTrackingState {
  activeTransactions: TrackedTransaction[];
  setActiveTransactions: (transactions: TrackedTransaction[]) => void;
  updateTransaction: (transaction: TrackedTransaction) => void;
  removeTransaction: (txId: string) => void;
}

export const useTransactionTrackingStore = create<TransactionTrackingState>(
  (set) => ({
    activeTransactions: [],

    setActiveTransactions: (transactions: TrackedTransaction[]) =>
      set({ activeTransactions: filterVisibleLiveTransactions(transactions) }),

    updateTransaction: (transaction: TrackedTransaction) =>
      set((state) => {
        const index = state.activeTransactions.findIndex(
          (tx) => tx._id === transaction._id
        );
        if (index >= 0) {
          // Update existing
          const updated = state.activeTransactions.map((t, i) =>
            i === index ? { ...t, ...transaction } : t
          );
          return {
            activeTransactions: filterVisibleLiveTransactions(updated).slice(
              0,
              10
            ),
          };
        }
        // Add new at the beginning
        return {
          activeTransactions: filterVisibleLiveTransactions([
            transaction,
            ...state.activeTransactions,
          ]).slice(0, 10),
        };
      }),

    removeTransaction: (txId: string) =>
      set((state) => ({
        activeTransactions: state.activeTransactions.filter(
          (tx) => tx._id !== txId
        ),
      })),
  })
);
